import { render, staticRenderFns } from "./CRTextArea.vue?vue&type=template&id=703f834b&scoped=true"
import script from "./CRTextArea.vue?vue&type=script&lang=js"
export * from "./CRTextArea.vue?vue&type=script&lang=js"
import style0 from "./CRTextArea.vue?vue&type=style&index=0&id=703f834b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "703f834b",
  null
  
)

export default component.exports